import { Declaration } from './declaration.model';

export class ListDeclaration {
    constructor(public maxDeclaration?:number,
        public declarations?:Declaration[]){}
}